export default "__VITE_ASSET__v94wL4Zv__"